/**
 * @file vuexstore for states used by the active draft post composer modal
 */
import { DockableModalState } from 'types'
import { Module } from 'vuex'
import { RootState } from 'vuexstore/surface/types'

interface ComposerModalState {
  modalState: DockableModalState
  scrolledToTop: boolean
  scrolledToBottom: boolean
  // flag to indicate whether the composer modal should focus on attachment caption on load
  shouldFocusAttachmentCaption: boolean
}

const initialState = (): ComposerModalState => {
  return {
    modalState: 'expanded',
    scrolledToTop: false,
    scrolledToBottom: false,
    shouldFocusAttachmentCaption: false,
  }
}

const composerModal: Module<ComposerModalState, RootState> = {
  namespaced: true,
  state: initialState(),
  getters: {
    modalState: (state): DockableModalState => state.modalState,
    isDocked: (state): boolean => state.modalState === 'docked',
    isExpanded: (state): boolean => state.modalState === 'expanded',
    scrolledToTop: (state): boolean => state.scrolledToTop,
    scrolledToBottom: (state): boolean => state.scrolledToBottom,
    shouldFocusAttachmentCaption: (state): boolean => state.shouldFocusAttachmentCaption,
  },
  mutations: {
    DOCK_MODAL(state): void {
      state.modalState = 'docked'
    },
    EXPAND_MODAL(state): void {
      state.modalState = 'expanded'
    },
    UPDATE_SCROLL_POSITION(state, { scrolledToTop, scrolledToBottom }): void {
      state.scrolledToTop = scrolledToTop
      state.scrolledToBottom = scrolledToBottom
    },
    SET_SHOULD_FOCUS_ATTACHMENT_CAPTION(state): void {
      state.shouldFocusAttachmentCaption = true
    },
    CLEAR_SHOULD_FOCUS_ATTACHMENT_CAPTION(state): void {
      state.shouldFocusAttachmentCaption = false
    },
  },
  actions: {
    dock({ commit }): void {
      commit('DOCK_MODAL')
    },
    expand({ commit }): void {
      commit('EXPAND_MODAL')
    },
    updateScrollPosition({ commit }, { scrolledToTop, scrolledToBottom }): void {
      commit('UPDATE_SCROLL_POSITION', { scrolledToTop, scrolledToBottom })
    },
    setShouldFocusAttachmentCaption({ commit }): void {
      commit('SET_SHOULD_FOCUS_ATTACHMENT_CAPTION')
    },
    clearShouldFocusAttachmentCaption({ commit }): void {
      commit('CLEAR_SHOULD_FOCUS_ATTACHMENT_CAPTION')
    },
  },
}

export default composerModal
export { ComposerModalState }
